export default __webpack_public_path__ + "static/media/checkbox-blue.062dcd2b.svg";